@import '../general';
@import 'toggle';

:host {
  display: block;
}

.elm-toggle::before {
  box-sizing: inherit;
}
